import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import CategoryStrip from '../components/CategoryStrip';
import BenefitsStrip from '../components/BenefitsStrip';
import PromoBanners from '../components/PromoBanners';
import FreshPicks from '../components/FreshPicks';
import WebsiteOffers from '../components/WebsiteOffers';
import Testimonials from '../components/Testimonials';
import Wholesale from '../components/Wholesale';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import StorefrontServiceabilityGate from '../components/StorefrontServiceabilityGate';
import usePageMetadata from '../hooks/usePageMetadata';
import { scrollToHash } from '../config/navigation';

// Section order follows the approved Home design: hero → category rail →
// trust strip → promotional banners → Today's Fresh Picks → testimonials →
// wholesale (with its promise strip) → contact → footer. "Offers for You"
// (the website's live promotions at this location) keeps its place after the
// picks and is only there when the backend returns offers.
const HomePage = () => {
  const { hash } = useLocation();

  usePageMetadata({
    title: 'Fresh & Homely',
    description:
      'Fresh & Homely is a neighbourhood meat, seafood, dairy and grocery store in Bengaluru, offering handpicked cuts, honest pricing and hygienically packed freshness every day.',
    canonicalPath: '/',
  });

  // Handles arriving from another route with a section hash (e.g. /#contact).
  // The sections render synchronously, so one frame is enough for layout to
  // settle before we measure offsetTop.
  useEffect(() => {
    if (!hash) return undefined;
    const frame = requestAnimationFrame(() => scrollToHash(hash));
    return () => cancelAnimationFrame(frame);
  }, [hash]);

  return (
    <>
      <Navbar />
      <Hero />
      {/* Catalogue sections wait for a serviceable browsing location; the
          Hero's prompt explains what is missing, so they stay silent until
          then. The brand and information sections below are not scoped. */}
      <StorefrontServiceabilityGate variant="silent">
        <CategoryStrip />
      </StorefrontServiceabilityGate>
      <BenefitsStrip />
      <StorefrontServiceabilityGate variant="silent">
        <PromoBanners />
        <FreshPicks />
        <WebsiteOffers />
      </StorefrontServiceabilityGate>
      <Testimonials />
      <Wholesale />
      <Contact />
      <Footer />
    </>
  );
};

export default HomePage;
